import { render, staticRenderFns } from "./MatchTableItem.vue?vue&type=template&id=2aaf7554&"
import script from "./MatchTableItem.vue?vue&type=script&lang=js&"
export * from "./MatchTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports